exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-header[data-v-5563f08c] {\n  background: var(--sidebar-selected);\n  color: #FFF;\n}\n.close-absolute[data-v-5563f08c] {\n  position: absolute;\n  right: 25px;\n  top: 50%;\n  color: #e30202;\n  font-size: 1.2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0.5;\n  transition: 0.2s all;\n  transform: translateY(-50%);\n}\n.close-absolute[data-v-5563f08c]:hover {\n  opacity: 1;\n  color: #ba0101;\n}", ""]);

// exports
